import React, { createRef, Component } from "react";
import { Row, Input, Select } from "antd";
import moment from "moment";
import "moment-timezone";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { EditButtonComponent, CSREditButtonComponent } from "../../../../CommonComponents/CTA/Buttons";
import TooltipComponent from "../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import AccountAdvisorSection from "../../Components/AccountAdvisor/AccountAdvisorSection";
import WebView from "../../Components/DesignatedAccess/WebView";
import EditView from "../../Components/DesignatedAccess/EditView";
import SuccessionComponent from "../../Components/SuccessionComponent/SuccessionComponent";
import KnowAccessLevel from "../../Components/PopUp/KnowAccessLevel";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import PrintComponents from "react-print-components";
import PendingAlert from "../../Components/PendingAlert/PendingAlert";
import { UnderLine } from "../../Components/SuccessionComponent/styles";
import {LinkForModal} from "../../Components/PopUp/styles";
import AdditionalAccountInfoForGemini from "../../Components/AdditionalAccountInfo/AdditionalAccountInfoSection"
import CSREditLinkToPill from "../../../../CommonComponents/EditLinkToPill/CSREditLinkToPill";
import _ from "lodash";
import { 
  EDIT_SUCCESSION_PLAN, 
  EDIT_OTHER_ACCOUNT_ROLES,
  POPULATE_STANDING_LOA,
  EDIT_ACCOUNT_NAME
} from "../../../../CSR/utils/geminiUrlMapper";
import PropTypes from 'prop-types';
import {
  FixedWidth,
  PagesHeading,
  DataHeading,
  DataValue,
  DisplayFlex,
  SectionLastHeading,
  BlurContainer,
  BlurOverlay,
  SectionDivider,
  StyleLessButton,
  JustifyBetween,
  ErrLength,
  AlignItemsCenter} from "../../../../CommonComponents/commonStyles";
import history from "../../../../history/history";
import printIcon from "../../../../assets/icons/print.svg";
import {
  ItemData,
  JustifyBetweenAccessLevel,
  IconPadding,
  DataExportPrint,
  AccountNameEdit,
  AccountNameEditParent,
  PrimaryAccount,
  AlignItemsCenter1,
  Loader,
  SaveLink,
  LinkCol,
  EditButton,
  MyAccountSelect} from "../../styles";

import {
  showComponent,
  changeName,
  newFundName,
  changePrimary,
  savePrimaryAccount,
  fetchMyAccountData,
  newFundNameForSave,
  addDesignated,
  fetchMyAccountMapping
} from "../../actions";
import {fetchDocumentCentreData} from "../../../DocumentCentre/Pages/actions"
import {
  getPrimaryAccount,
  getAccountData,
  isGeminiUser
} from "../../../../utils/sessionUtil";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MyAccountsPrint from "./MyAccountsPrint";
import { getpwUrl, initiateTracking, recordError, todayDate } from "../../../../utils/commonUtil";
import regexMap from "../../../../utils/regexMap";
import Contents, { ContentProvider, ContentMessage, Types } from "../../../../CommonComponents/ContentMessages";
import {
  downloadFileFromUrl
} from '../../../../services/apiServices';
import { myAccountDerivedStates } from '../../selectors';
import PrintButton from "../../../../CommonComponents/PrintButton/PrintButton";
import Messages,{MessageComponent} from "../../../../CommonComponents/Messages";

class MyAccount extends Component {
  constructor(props) {
    super(props);
    this.pageTitle = '';
    this.authorizationTitle = '';
    this.successionTitle = '';
    this.iipTitle = '';
    
    this.state = {
      newFund: "",
      newPrimary: "",
      fundNameBlur: false,
      isEnabled: true,
      accContactBlur: false,
      additionalAccDataBlur: false,
      accAdvisorBlur: false,
      desigAccessBlur: false,
      successPlanBlur: false,
      authorizationBlur: false,
      advisorType: "",
      accountNameErrorIssue: "",
      editAdvisorRole: "full",
      fromCSREditButton: false,
      showmessage:false,
      messageText:null
    };
  }

  setTitle = (title = '', type = '') => {
    
    if(type === 'myAccount') {
      this.pageTitle = title;
    }
    
    if(type === 'iip') {
      this.iipTitle = title;
    }

    if(type === 'succession'){
      this.successionTitle = title;
    }

    if(type === 'authorization') {
      this.authorizationTitle = title;
    }
  }

  getPageTitle = () => {
    return this.pageTitle;
  }

  setDesc = (content) => {
    setTimeout(() => {
      let elem = document.querySelector('#standingLetterPdfLink a');    
      if(elem) {
        let elemText = elem.textContent;
        elem.addEventListener('click', () => {          
          initiateTracking("download", this.pageTitle, this.authorizationTitle, elemText);        
        })
      }
    });
  }

  downLoadFile(docId) {

    let url = `/donor-portal/api/account/${getPrimaryAccount().userId}/getAccountDocumentsByAccountIdAndDocId?docId=${docId}`;
  
    downloadFileFromUrl(url);
 
  }

  setPendingAlertLink = (content) => {    
    setTimeout(() => {
      let elem = document.querySelector('p#standingLetterPendingAlert a');      
      if(elem) {
        let elemText = elem.textContent;        
        elem.addEventListener('click', (e) => {   
          initiateTracking("download", this.pageTitle, this.authorizationTitle, elemText);
        })
      }
    })
  }

  componentDidMount() {    

    if (!this.props.toChangePrimary) {
      this.props.changePrimary();
    }
    if (!this.props.toChangeName) {
      this.props.changeName();
    }
    if (!this.props.toUpdate) {
      this.props.showComponent();
    }
    this.props.requestData({
      userId: getPrimaryAccount().userId,
      partyId: getAccountData().partyId
    });

    this.props.addDesignated({
      metaData: {
        method: "GET",
        url: `/interested-party`,
        page: "myAccount",
        isExternal: true
      }
    });
    this.props.fetchCountryMapping({
      metaData: {
        method: "GET",
        url: "/donor-portal/api/dropDownValues/getCodeValueMapping",
        page: "myAccount"
      }
    })

    let data = {};
        data = {
            metaData: {
            method: "GET",
            page: "documentCentre",
            url: {
                documentCentre: `/donor-portal/api/account/${getPrimaryAccount().userId}/getAccountDocumentsByAccountIdAndPartyIdAndType/${getAccountData().partyId}?startDateStr=01/01/1990&endDateStr=${todayDate()}&type=ALL`
               
              }
            }
        };
        this.props.documentCentreData(data);


        if (history.location.state) {
          let state = {};
          if(history.location.state.showSuccessMessage)
          {
          this.setState({
            showmessage: true,
            messageText:history.location.state.messageText
          },()=>{
            setTimeout(()=>{
              this.setState({
                showmessage: false
              })
            },15000)
          });   
          history.replace({ ...history.location, state });
        }
      }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.accountID !== this.props.accountID) {
      history.push("/");
    }   
    
    if (nextProps.editAdvisorRole !== this.props.editAdvisorRole) {
      this.setState({
        editAdvisorRole: nextProps.editAdvisorRole
      });      
    }

    if (nextProps.isLoadingAccount === false) {
      this.setState({
        newFund: this.trimNewFund(nextProps.fundName)
      });

      if(nextProps.primaryContactFullName !== this.props.primaryContactFullName || this.state.newPrimary !== nextProps.primaryContactFullName ) {        
        this.setState({
          newPrimary: nextProps.primaryContactFullName
        });
      }
    }
  }


  toggleisEnabled = () => {
    window.scrollTo(0, 0);
    this.viewComponent(false);
  };
  changeFundName(bool) {
    try {
      this.setState({ accountNameErrorIssue: "" });
      if (bool == false) {
        this.reinitializeState(this.props.changeName);
      } else {
        this.setState(
          {
            fundNameBlur: false,
            accContactBlur: true,
            accAdvisorBlur: true,
            additionalAccDataBlur: true,
            desigAccessBlur: true,
            successPlanBlur: true,
            authorizationBlur: true,
            fromCSREditButton: false
          },
          () => {
            this.props.changeName();
          }
        );
      }
    } catch (error) {
      recordError(error);
    }
  }

  editSuccession() {
    initiateTracking("edit", this.pageTitle, this.successionTitle, "Edit");
    history.push("/my-account/edit-legacy-options");
  }
  standingLetterPdfLink = () => {
    initiateTracking("download", this.pageTitle, this.authorizationTitle, "Standing Letter of Authorization ");
    window.open("https://www.vanguardcharitable.org/sites/default/files/upload/VOTLOAW_072011.pdf", '_blank');
  }
  changePrimaryAccount(bool, ...rest) {
    try {
      if (bool == false) {
        this.reinitializeState(this.props.changePrimary);
      } else {
        this.setState(
          {
            fundNameBlur: true,
            accContactBlur: false,
            accAdvisorBlur: true,
            additionalAccDataBlur: true,
            desigAccessBlur: true,
            successPlanBlur: true,
            authorizationBlur: true,
            fromCSREditButton: rest[0] === true
          },
          () => {
            this.props.changePrimary();
          }
        );
      }
    } catch (error) {
      recordError(error);
    }
  }

  viewComponent(bool) {
    if (bool === false) {
      this.reinitializeState(this.emptyFunc);
    } else {
      this.setState(
        {
          fundNameBlur: true,
          accContactBlur: true,
          accAdvisorBlur: true,
          additionalAccDataBlur: true,
          desigAccessBlur: false,
          successPlanBlur: true,
          authorizationBlur: true,
          fromCSREditButton: false
        },
        () => {
          this.props.showComponent();
        }
      );
    }
  }

  emptyFunc() { }

  reinitializeState(callback) {
    this.setState(
      {
        fundNameBlur: false,
        accContactBlur: false,
        accAdvisorBlur: false,
        additionalAccDataBlur: false,
        desigAccessBlur: false,
        successPlanBlur: false,
        authorizationBlur: false,
        fromCSREditButton: false
      },
      () => {
        callback();
      }
    );
  }

  trimNewFund(fundName) {
    let newFundNme1 = fundName.replace("The ", "").replace(" Fund", "");
    return newFundNme1.trim();
  }
  validateFundName() {
    let e = this.state.newFund;
    let arr = null;
    let len = null;
    if (e) {
      arr = e.split(" ");
      len = arr.length;
    }
    let str = e;
    str = str.replace(/[^a-zA-Z]/g, "");
    let num = str.replace(/[^0-9]/g, "");

    if (!e) {
      this.setState({
        accountNameErrorIssue: (
          <ErrLength>Please specify an account name to continue</ErrLength>
        )
      });
    } else if(regexMap.eliminateSpecialCharacter.test(e)) {
      this.setState({
        accountNameErrorIssue: (
          <ErrLength>{'The following special characters are not allowed : |, <, >'}</ErrLength>
        )
      });
    } else if (e.length > 71) {
      this.setState({
        accountNameErrorIssue: (
          <ErrLength>Maximum length is 80 letters</ErrLength>
        )
      });
    } else if (e.length < 2) {
      this.setState({
        accountNameErrorIssue: (
          <ErrLength>
            {" "}
            We apologize for any inconvenience, but this account name is not
            eligible as an account name due to the following reason: Account
            name is too short.
          </ErrLength>
        )
      });
    } else if (!(str.length > 1) && !(num.length > 1)) {
      this.setState({
        accountNameErrorIssue: (
          <ErrLength> Please use at least 2 alphabets or 2 numbers</ErrLength>
        )
      });
    } else if (
      arr && arr[0] && (arr[0].toLowerCase() === "the" ||
        arr[len - 1].toLowerCase() === "fund")
    ) {
      this.setState({
        accountNameErrorIssue: (
          <ErrLength>
            We apologize for any inconvenience, but this account name is not
            eligible as an account name due to the following reason: Name of the
            Program Account already begins with "The" or ends with "Fund"
          </ErrLength>
        )
      });
    } else if (
      e.toLowerCase().includes("trust") ||
      e.toLowerCase().includes("endowment") ||
      e.toLowerCase().includes("foundation")
    ) {
      this.setState({
        accountNameErrorIssue: (
          <ErrLength>
            The Account Name cannot contain words "Trust", "Endowment" and
            "Foundation". Please correct to continue
          </ErrLength>
        )
      });
    } else {
      this.setState({ accountNameErrorIssue: "" });
    }
  }

  handleFund(e) {
    if (/^.{0,71}$/.test(e.target.value)) {
      this.setState({ newFund: e.target.value }, () => {
        this.validateFundName();
      });
    }
  }

  accountDocumentsByVC =() =>{
    let accountDocumentsVc =this.props.accountDocuments;
    let count=0;;
    let html;
    html = accountDocumentsVc.map((item) => {
      if(item.uploadedByVC && item.successionPlanDoc){
        count++;
        return(<LinkCol key={item.name+item.date} lg={8} md={12} xs={24} >
          <DataHeading>
         
          <a data-test="accountDocLink" onClick={() => {  this.downLoadFile(item.docId) }}><UnderLine>{item.name}</UnderLine></a>
          </DataHeading>
        </LinkCol>);
      }
    });
    if(count){
      return html
    }else{
      return (<DataHeading>None on file</DataHeading>)
    }
  }

  standingPendingAlert = () => {
    if (
      this.props.accData &&
      this.props.accData.authorization &&
      this.props.accData.authorization.vanguardAccounts.length > 0
    ) {
      return this.props.accData.authorization.vanguardAccounts.map(
        (accounts,index) => {
          let expDate = accounts.receivedDate + 157784630000;
          let expStartDate = expDate - 7776000000;
          let expEndDate = expDate + 2592000000;

          if (
            accounts.accountRegistration === "Private Foundation" ||
            accounts.accountRegistration === "Other"
          ) {
            if (Date.now() <= expDate && Date.now() >= expStartDate) {
              return (                
                  <PendingAlert key={index} TopMargin='0px' BottomMargin='20px'>
                    <p id="standingLetterPendingAlert"><strong>Alert : </strong>The current Standing Letter of Authorization  on file for account number{' '}
                    {accounts.accountNumber} is about to expire. Please submit a new{' '}
                      <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} inline={true} page="Standing Letter" setTitle={this.setPendingAlertLink} property="description__value" defaultMessage='<a href="https://www.vanguardcharitable.org/sites/default/files/upload/VOTLOAW_072011.pdf" target="_blank" >Standing Letter of Authorization form</a>'/>
                    {' '}soon.</p>                        
                  </PendingAlert>                      
              )                   
                  
            } else if (Date.now() > expDate && Date.now() <= expEndDate) {
              return (
                <PendingAlert key={index} TopMargin='0px' BottomMargin='20px'>
                    <p id="standingLetterPendingAlert"><strong>Alert : </strong>The current Standing Letter of Authorization  on file for account number{' '}
                    {accounts.accountNumber} has expired. Please submit a new{' '}
                      <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} inline={true} page="Standing Letter" setTitle={this.setPendingAlertLink} property="description__value" defaultMessage='<a href="https://www.vanguardcharitable.org/sites/default/files/upload/VOTLOAW_072011.pdf" target="_blank" >Standing Letter of Authorization form</a>'/>
                    {' '}soon.</p>                        
                  </PendingAlert>                             
              );
            }
          }
        }
      );
    }
  };
  handleSaveFund = () => {
    try {
      this.setState({ accountNameErrorIssue: "" });
      let name = "The " + this.state.newFund + " Fund";
      this.reinitializeState(this.props.changeName);
      this.props.newFundName({
        metaData: {
          method: "POST",
          url: `/DP/FinancialAccount/UpdateName`,
          page: "myAccount",
          data: {fundName:name,accountId:getPrimaryAccount().userId},
          isBhoomiUrl:true
        }
      });
    } catch (error) {
      recordError(error);
    }
  };

  handleSavePrimary = () => {
    try {
      const { accData } = this.props;
      this.reinitializeState(this.emptyFunc);
      let dataArr = accData.primaryAccountContact;
      let roleId = 0, primaryName = '', roleType = '';
      dataArr.map(item => {  
        if (this.state.newPrimary.trim().includes(item.name.trim())) {
          item.primary = "1";
          roleId = item.roleId;
          primaryName = item.name;
          roleType = item.roleType;
        } else {
          item.primary = 0;
        }
      });
  
      let nextAccountAdvisors = JSON.parse(
        JSON.stringify(accData.accountAdvisors)
      );
  
      nextAccountAdvisors.forEach(item => {
        if (this.state.newPrimary.trim().includes(item.name.trim())) {
          item.primaryAccountContact = true;
        } else {
          item.primaryAccountContact = false;
        }
      });
  
      let nextDesignatedParties = JSON.parse(
        JSON.stringify(accData.designatedParties)
      );
  
      nextDesignatedParties.forEach(item => {
        if (this.state.newPrimary.trim().includes(item.name.trim())) {
          item.primaryAccountContact = true;
        } else {
          item.primaryAccountContact = false;
        }        
      });
  
      let payload = {};
      payload.nextAccountAdvisors = nextAccountAdvisors;
      payload.nextDesignatedParties = nextDesignatedParties;    
  
      this.props.savePrimaryAccount({
        metaData:
        {
          method: "POST",
          url: `/DP/FinancialAccountRole/UpdatePrimaryContact`,
          page: "myAccount",
          data: {
            contactData:dataArr.sort((a,b)=>{
              return a.primary > b.primary ? -1 : (a.primary < b.primary ? 1: 0);
            }),
            accountId:getPrimaryAccount().userId
          },
          isBhoomiUrl:true
        },
        payload: payload,
        prevData: accData,
        name: primaryName,
        roleType
      });
    } catch (error) {
      recordError(error); 
    }
  };

  getChangeFundName = () => {
    return this.state.newFund;
  };

  handlePrimary = value => {  
    this.setState({ newPrimary: value });
  };

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: () => <ContentMessage data-test="breadCrump-block" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_page_title" defaultMessage="My Account" setTitle={ (title) => this.setTitle(title, 'myAccount') }/>,
        path: "/my-account"
      }
    ];
  };
  
  checkForNull = (name) => {
    if (name !== null) {
      return name;
    }
    return "";
  }

  // Check No access level Only for CSR user
  checkNoAccess = () => { 
    return isGeminiUser() && getPrimaryAccount().role.access === 'No Access';
  }

  // Check account role is "primary account donor" - CSR User
  checkPrimarAccoutDonor = () => {
    const { AdditionalAccountDetails } = this.props;
    return isGeminiUser() && AdditionalAccountDetails === "Donor"
  }

  // Check account role is Designated party - CSR User
  checkDesignatedParty = () => {
    const { AdditionalAccountDetails } = this.props;
    return isGeminiUser() && AdditionalAccountDetails === "Designated Party"
  }

  // Check account role is Trusted advisor - CSR User
  checkTrustedAdvisor = () => {
    const { AdditionalAccountDetails } = this.props;
    return isGeminiUser() && AdditionalAccountDetails === "Trusted Advisor"
  }

  checkNoWebAccess = () => {
    const { navBarData } = this.props;
    return isGeminiUser() && navBarData && !navBarData.webAccess
  }

  //Disable Edit function w.r.t csr criteria
  checkDisableCriteriaForCsr = () => (this.checkPrimarAccoutDonor() || this.checkDesignatedParty() || this.checkTrustedAdvisor()) && (this.checkNoAccess() || this.checkNoWebAccess());

  getAutherizationDefaultContent = () => (    
    `<p>
        If an account number is listed below, you have a
        Standing letter of authorization  (SLOA) for that Vanguard account
        on file with Vanguard Charitable. A Letter of authorization is not
        needed for subsequent gifts from this account.
      </p>           
      <p>
        If you are interested in providing Vanguard Charitable the
        authority to give instructions on a Vanguard and/or VBS account,
        please download, complete, and mail a <a href="https://www.vanguardcharitable.org/sites/default/files/upload/VOTLOAW_072011.pdf" target="_blank">Standing letter(s) of authorization </a> to Vanguard Charitable. This form requires an
        acknowledgement of signature from a notary public.
      </p>`
  )

  render() {
    const ref = createRef();
    const {
      legacyData,
      accData,
      isLoadingAccount,
      toUpdate,
      toChangeName,
      toChangePrimary,
      navBarData,
      csrBusinessFunction,
      updateDone,
      accountDocuments,
      vanguardAccts
    } = this.props;
    const { newFund, newPrimary } = this.state;

    if (isLoadingAccount) return <Preloader data-test="myaccount-preloader"/>;

    const PrintText = props => {
      return (
        <DataExportPrint><a onClick={() => initiateTracking("print", this.pageTitle, "", props.children)}>{props.children}</a></DataExportPrint>
      )
    };  
    return (
     
      <ContentProvider types={[Types.SUB_HEADING_LEGACY_OPTIONS]} pages={['My Account', 'Legacy options']} data-test="myaccount">      
        <div className="My-Account-Details">
          <FixedWidth>
            <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          </FixedWidth>
          <FixedWidth>  
            <MessageComponent show={this.state.showmessage}>
              {`You Successfully added an ${this.state.messageText}`}
              </MessageComponent>    
            <BlurContainer ref={ref}>
              <BlurOverlay isEnabled={!this.state.fundNameBlur} />
              {/****************************** CHANGE FUND NAME **************************************/}
              {toChangeName ? (
                <div className="change-fund-name">
                  <PagesHeading className="align-items-center" id="btnEditFundName">
                    {this.props.pageTitle}
                    <EditButtonComponent
                      disabled={
                        getPrimaryAccount().role.access === "Read Only" || this.props.AdditionalAccountDetails !== "Account Advisor" || this.checkDisableCriteriaForCsr()
                          ? true
                          : false
                      }
                      className="ml-10 inline-block"
                      buttonName="Edit"
                      clicked={this.changeFundName.bind(this, true)}
                    />
                    <div className="accountNameCSREdit">
                      { isGeminiUser() &&
                        <CSREditLinkToPill
                          toGeminiApp={true}
                          linkPathname={`${EDIT_ACCOUNT_NAME}?dafAccountId=${getPrimaryAccount().userId}`}
                        /> 
                      }
                    </div>
                  </PagesHeading>
                </div>
              ) : (
                  <>
                    <AccountNameEditParent className="change-fund-name">
                      <AccountNameEdit className="flex items-center">
                        The
                        <Input
                          aria-label="fund-name"
                          size="large"
                          placeholder="Enter fund name"
                          className="mx-10 not-rounded"
                          value={newFund}
                          onChange={this.handleFund.bind(this)}
                          onBlur={this.validateFundName.bind(this)}
                        />
                        Fund
                    </AccountNameEdit>
                      <PagesHeading className="ml-10">
                        ({accData.fundNumber})
                    </PagesHeading>
                      <div
                        className={
                          this.state.accountNameErrorIssue === ""
                            ? "ml-10"
                            : "ml-10 disable"
                        }
                      >
                        <SaveLink onClick={this.handleSaveFund} className={isGeminiUser() ? 'disable-hyperlink' : ''}>Save</SaveLink>
                      </div>
                      <div className="ml2" id="btnCancel">
                        <SaveLink onClick={this.changeFundName.bind(this, false)}>
                          Cancel
                        </SaveLink>
                      </div>
                    </AccountNameEditParent>
                    {this.state.accountNameErrorIssue}
                  </>
                )}
            </BlurContainer>

            <BlurContainer ref={ref}>
              <BlurOverlay isEnabled={!this.state.accContactBlur} />
              <>
                <PrintButton className={`i_print ${ !this.state.fundNameBlur ? "mobile-view-accountDetails" : "mobile-view-accountDetails hidden"}`}>
                  <div>
                      <MyAccountsPrint
                        data-test="myAccount-print-block"
                        accData={accData}
                        newFund={newFund}
                        newPrimary={newPrimary}
                        countryCodeMappingData={this.props.CountryCodeMappingData}
                        getAutherizationDefaultContent={() => this.getAutherizationDefaultContent()}
                      />
                  </div>
                  </PrintButton>
              </>
                {/****************************** CHANGE PRIMARY CONTACT **************************************/}
             
             <Messages/>
             
              {toChangePrimary ? (
                <JustifyBetween>
                  <PrimaryAccount className="mt2 change-primary-account primary-account-display">
                    <DataHeading>
                      Primary Account Contact
                      <TooltipComponent
                        text="The primary contact serves as the main point of contact for all account related questions or updates, and receives copies of all account confirmations."
                        className="lg-hide hide-only-md align-baseline"
                      />
                    </DataHeading>
                    {!updateDone ? (
                      <Loader>&nbsp; Loading...</Loader>
                    ) : (<DataValue className="mt0 ml-05 ml-sm-0">
                      {newPrimary}
                      <TooltipComponent
                        text="The primary contact serves as the main point of contact for all account related questions or updates, and receives copies of all account confirmations."
                        className="sm-hide align-baseline mr1"
                      />
                    </DataValue>)}
                    <EditButton className="ml2 primaryEditButtonPosition" id="btnPrimaryContactEditbtn">
                      <EditButtonComponent
                        className="ml-10"
                        disabled={
                          getPrimaryAccount().role.access === "Read Only" || this.checkDisableCriteriaForCsr() ||
                            accData.primaryAccountContact.length < 2
                            ? true
                            : false
                        }
                        buttonName="Edit"
                        clicked={this.changePrimaryAccount.bind(this, true)}
                      />
                    </EditButton>
                    { isGeminiUser() && <div className="ml2">
                      <CSREditButtonComponent
                        buttonName="CSR Edit"
                        clicked={this.changePrimaryAccount.bind(this, true, true)}
                        disabled={ true }
                      />
                      </div>
                    }
                  </PrimaryAccount>
                
                  <PrintButton className="i_print desktop-view-accountDetails">

                  <div>
                      <MyAccountsPrint
                        data-test="myAccount-print-block1"
                        accData={accData}
                        newFund={newFund}
                        newPrimary={newPrimary}
                        countryCodeMappingData={this.props.CountryCodeMappingData}
                        getAutherizationDefaultContent={() => this.getAutherizationDefaultContent()}
                      />
                    </div>

                  </PrintButton>

                
                </JustifyBetween>
              ) : (
                  <PrimaryAccount className="mt2 change-primary-account-edit">
                    <DataHeading>Primary Account Contact</DataHeading>
                    <AlignItemsCenter>
                      {!updateDone ? (
                        <Loader>&nbsp; Loading...</Loader>
                      ) : (
                          <MyAccountSelect
                            data-test="account-contact"
                            aria-label="change-primary-account-contact"
                            role={false}
                            dropdownClassName="advisorSel"
                            getPopupContainer={trigger => trigger.parentNode}
                            defaultValue={this.state.newPrimary}
                            onSelect={e => this.handlePrimary(e)}
                            className="mt0 ml-05"
                            mobileWidth="60%"
                          >
                            {accData.primaryAccountContact.map((item, index) => (
                              <Select.Option key={index} value={item.name} title={item.name}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </MyAccountSelect>
                        )}
                      <div className="ml2" id="btnPrimaryContactSavebtn">
                        <SaveLink onClick={this.handleSavePrimary} className={isGeminiUser() && !this.state.fromCSREditButton ? 'disable-hyperlink' : ''}>Save</SaveLink>
                      </div>
                      <div className="ml2" id="btnPrimaryContactCancelbtn">
                        <SaveLink onClick={this.changePrimaryAccount.bind(this, false)}>
                          Cancel
                        </SaveLink>
                      </div>
                    </AlignItemsCenter>
                  </PrimaryAccount>
                )}
            </BlurContainer>

            <BlurContainer ref={ref} className="mt-xs-20">
              <BlurOverlay isEnabled={!this.state.authorizationBlur} />
              <DisplayFlex className="mt1 date-open">
                <DataHeading>Date Opened </DataHeading>
                <DataValue className="mt0 ml-05">
                  {moment(
                    moment.tz(accData.dateOpened, "America/New_York")
                  ).format("L")}
                </DataValue>
              </DisplayFlex>
              <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION]} pages={["Standing Letter"]}>
                {this.standingPendingAlert()}
              </ContentProvider>              
            </BlurContainer>

            {/****************************** For Gemini User Only **************************************/}
            { isGeminiUser() && <AdditionalAccountInfoForGemini navBarData={navBarData} blur={!this.state.additionalAccDataBlur} csrBusinessFunction={csrBusinessFunction}/> }


            {/****************************** ADVISOR **************************************/}

            <AccountAdvisorSection
              edit={
                getPrimaryAccount().role.access === "Read Only" || this.checkDisableCriteriaForCsr() ? true : false
              }
              addSecondaryDisable={
                getPrimaryAccount().role.access === "Read Only" || this.props.AdditionalAccountDetails !== "Account Advisor" || this.checkDisableCriteriaForCsr()
                  ? true
                  : false
              }
              pageTitle={this.getPageTitle.bind(this)}
              accData={this.props.accData}
              advisorType={this.state.editAdvisorRole}
              blur={!this.state.accAdvisorBlur}
              advisors={accData.accountAdvisors}
              countryCodeMappingData={this.props.CountryCodeMappingData}
            />

            {/******************************* DESIGNATED *************************************/}

            <SectionDivider />
            <BlurContainer ref={ref} className="change-designated-edit">
              <BlurOverlay isEnabled={!this.state.desigAccessBlur} />
              <JustifyBetweenAccessLevel>
                <AlignItemsCenter1>
                  <SectionLastHeading className="mb0">
                    <ContentMessage data-test="interested-party-block" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_2_title" defaultMessage="Interested party details" setTitle={ (title) => this.setTitle(title, 'iip') }/>
                  </SectionLastHeading>
                  {toUpdate ? (
                    <>
                    <div className="ml2" id="btnEditInterestedParty">
                      <EditButtonComponent
                        disabled={
                          getPrimaryAccount().role.access === "Read Only" ||
                            accData.designatedParties.length === 0 || this.props.AdditionalAccountDetails !== "Account Advisor" || this.checkDisableCriteriaForCsr()
                            ? true
                            : false
                        }
                        buttonName="Edit"
                        clicked={this.viewComponent.bind(this, true)}
                      />
                    </div>
                    { isGeminiUser() && <CSREditLinkToPill
                      className="ml2"
                      toGeminiApp={true}
                      linkPathname={`${EDIT_OTHER_ACCOUNT_ROLES}?dafAccountId=${getPrimaryAccount().userId}`}
                      /> 
                    }
                    </>
                  ) : (
                      ""
                    )}
                </AlignItemsCenter1>
                <ContentProvider types={[Types.GET_MODAL_CONTENT]} pages={['Access Modal']}>
                  <KnowAccessLevel />
                </ContentProvider>
              </JustifyBetweenAccessLevel>
              {toUpdate ? (
                !this.props.designatedUpadteLoader ? (
                  <WebView
                    roledetails={this.props.AdditionalAccountDetails}
                    accData={accData.designatedParties}
                    addBtn={true}
                    countryCodeMappingData={this.props.CountryCodeMappingData}
                  />
                ) : (
                    <Preloader />
                  )
              ) : (
                  <EditView
                    accData={accData.designatedParties}
                    toggleisEnabled={this.toggleisEnabled}
                  />
                )}
            </BlurContainer>

            {/****************************** SUCCESSION **************************************/}

            <SectionDivider />
            <BlurContainer ref={ref}>
              <BlurOverlay isEnabled={!this.state.successPlanBlur} />
              <JustifyBetweenAccessLevel>
                <AlignItemsCenter1>
                  <SectionLastHeading className="mb0">                    
                    <ContentMessage data-test="legacy-options-block" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_3_title" defaultMessage="My succession plan" setTitle={ (title) => this.setTitle(title, 'succession') }/>
                  </SectionLastHeading>
                  <EditButtonComponent
                    disabled={
                      getPrimaryAccount().role.access === "Read Only" || this.props.AdditionalAccountDetails !== "Account Advisor" || this.checkDisableCriteriaForCsr()
                        ? true
                        : false
                    }
                    buttonName="Edit"
                    clicked={this.editSuccession.bind(this)}
                    className="ml-10"
                  />
                  { isGeminiUser() && <CSREditLinkToPill
                    className='ml-15 successionCsrEdit'
                    toGeminiApp={true}
                    linkPathname={`${EDIT_SUCCESSION_PLAN}?dafAccountId=${getPrimaryAccount().userId}`}
                    disabled={ true }
                  /> }
                </AlignItemsCenter1>
                <LinkForModal id="anrSuccessionPlans" onClick={() => window.open(getpwUrl() + "/giving-with-vc/how-it-works/legacy-planning")}>Learn more about succession plans</LinkForModal>
              </JustifyBetweenAccessLevel>
              <Row className="mb-50 mt-30" type="flex">
              <LinkCol span={24}>
                <ItemData>                  
                  <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_4_title" defaultMessage="Account Documents"/>
                </ItemData>
              </LinkCol>
                  {accountDocuments && accountDocuments.length > 0 ? (
                  this.accountDocumentsByVC()
                  ) : (
                      <DataHeading>None on file</DataHeading>
                    )}
                    
              </Row>
              <SuccessionComponent pageTitle={this.getPageTitle.bind(this)} data={legacyData} />
            </BlurContainer>

            {/****************************** AUTHORIZATION **************************************/}

            <SectionDivider />
            <BlurContainer ref={ref}>
              <BlurOverlay isEnabled={!this.state.authorizationBlur} />
              <SectionLastHeading className="mb3">
              <ContentMessage data-test="authorization-block" type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_5_title" defaultMessage="Authorization" setTitle={ (title) => this.setTitle(title, 'authorization') }/>
              </SectionLastHeading>
              <DataHeading id="standingLetterPdfLink" className="mb2">                
                <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Account" property="field_type_5_description" setTitle={this.setDesc} defaultMessage={this.getAutherizationDefaultContent()}/>
              </DataHeading>        
              <Row className="mt3" type="flex">
                  <LinkCol lg={24} md={24} xs={24}>
                    <ItemData noMaxWidth>                      
                      <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Account" property="field_type_6_title" defaultMessage="Standing letter(s) of authorization on file"/>
                    </ItemData>
                </LinkCol>
              </Row>
              <Row type="flex">              
                  {vanguardAccts.length > 0 ? (
                    vanguardAccts.map((item, index) => (
                      <LinkCol key={index} lg={8} md={12} xs={24} className="mb2">
                      <DataHeading>
                        <span className={isGeminiUser() && _.includes(["Individual", "Joint", "Trust"], item.accountRegistration) ? 'oleGeminiBackground': ''}>
                          {item.accountNumber}
                        </span></DataHeading>
                      </LinkCol>
                    ))
                  ) : (
                      <DataHeading>None on file</DataHeading>
                    )}
              </Row>
              <Row>
                    { isGeminiUser() && <CSREditLinkToPill
                      className='my2'
                      toGeminiApp={true}
                      linkPathname={`${POPULATE_STANDING_LOA}?partyId=${getAccountData().partyId}&dafAccountId=${getPrimaryAccount().userId}`}
                    />
                    }
              </Row>
            </BlurContainer>
          </FixedWidth>
        </div>
      </ContentProvider>
    );
  }
}

const addressShape = PropTypes.shape({
  address: PropTypes.any,
  addressId: PropTypes.number,
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.any,
  addressLine3: PropTypes.any,
  addressType: PropTypes.any,
  addressUpdated: PropTypes.bool,
  city: PropTypes.string,
  country: PropTypes.string,
  primary: PropTypes.number,
  state: PropTypes.string,
  zipCode: PropTypes.string
});

const roleShape = PropTypes.shape({
  name: PropTypes.any,
  primary: PropTypes.any,
  roleId: PropTypes.number,
  roleType: PropTypes.any,
  roleTypeId: PropTypes.number,
  suffix: PropTypes.any
});

const appointShape = PropTypes.shape({
  additionalText: PropTypes.any,
  options: PropTypes.arrayOf(PropTypes.any),
  totalPercentage: PropTypes.number
})

MyAccount.propTypes = {
  AdditionalAccountDetails: PropTypes.string,
  CountryCodeMappingData: PropTypes.arrayOf(PropTypes.shape({
    desc: PropTypes.string,
    value: PropTypes.string
  })),
    accData: PropTypes.shape({
      accountAdvisors: PropTypes.arrayOf(PropTypes.shape({
        accountId: PropTypes.any,
        accountNumber: PropTypes.any,
        address: addressShape,
        addresses: PropTypes.arrayOf(addressShape),
        convertedLogin: PropTypes.any,
        dateOfBirthStr: PropTypes.string,
        deliveryMethod: PropTypes.string,
        dob: PropTypes.number,
        dobStr: PropTypes.any,
        email: PropTypes.string,
        emails: PropTypes.arrayOf(PropTypes.shape({
          addressId: PropTypes.number,
          emailId: PropTypes.string,
          emailType: PropTypes.string,
          primary: PropTypes.number
        })),
        firstName: PropTypes.string,
        gender: PropTypes.string,
        lastName: PropTypes.string,
        marritalStatus: PropTypes.any,
        middleName: PropTypes.any,
        name: PropTypes.string,
        partyId: PropTypes.number,
        permissionToShare: PropTypes.string,
        phone: PropTypes.string,
        phones: PropTypes.arrayOf(PropTypes.shape({
          addressId: PropTypes.number,
          phoneNumber: PropTypes.string,
          phoneType: PropTypes.string,
          primary: PropTypes.number
        })),
        preferredContactMethod: PropTypes.any,
        primary: PropTypes.bool,
        primaryAccountContact: PropTypes.bool,
        referralComments: PropTypes.any,
        referralValue: PropTypes.any,
        relatedDonor: PropTypes.any,
        role: roleShape,
        ssn: PropTypes.string,
        suffix: PropTypes.string,
        title: PropTypes.string,
        userId: PropTypes.string,
        webAccess: PropTypes.string
      })),
      authorization: PropTypes.shape({
        letters: PropTypes.arrayOf(PropTypes.any),
        vanguardAccounts: PropTypes.arrayOf(PropTypes.shape({
          accountName: PropTypes.string,
          accountNumber: PropTypes.string,
          accountRegistration: PropTypes.string,
          formLink: PropTypes.any,
          receivedDate: PropTypes.number
        }))
      }),
      dateOpened: PropTypes.number,
      designatedParties: PropTypes.arrayOf(PropTypes.shape({
        access: PropTypes.string,
        address: addressShape,
        email: PropTypes.string,
        firm: PropTypes.any,
        lastName: PropTypes.string,
        middleName: PropTypes.any,
        name: PropTypes.string,
        partyId: PropTypes.number,
        permissionToShare: PropTypes.string,
        phone: PropTypes.string,
        primaryAccountContact: PropTypes.bool,
        relType: PropTypes.number,
        relation: PropTypes.any,
        role: PropTypes.string,
        salutation: PropTypes.string,
        suffix: PropTypes.string,
        webAccess: PropTypes.string
      })),
      fundNumber: PropTypes.string,
      legacy: PropTypes.shape({
        bestow: PropTypes.number,
        bestowLegacy: PropTypes.shape({
          appoint: appointShape,
          create: appointShape
        }),
        endow: PropTypes.number,
        endowLegacy: PropTypes.shape({
          endow: appointShape,
          give: appointShape,
          grant: appointShape
        }),
        otherLegacy: PropTypes.shape({
          additionalText: PropTypes.any,
          totalPercentage: PropTypes.number
        }),
        others: PropTypes.number
      }),
      primaryAccountContact: PropTypes.arrayOf(roleShape),
      accountDocuments: PropTypes.arrayOf(PropTypes.any),

  }),
   
  accountID: PropTypes.string,
  addDesignated: PropTypes.func,
  changeName: PropTypes.func,
  changePrimary: PropTypes.func,
  csrBusinessFunction:PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any),PropTypes.object]),
  designatedUpadteLoader: PropTypes.bool,
  documentCentreData: PropTypes.func,
  fetchCountryMapping: PropTypes.func,
  isLoadingAccount: PropTypes.bool,
  newFundName: PropTypes.func,
  requestData: PropTypes.func,
  savePrimaryAccount: PropTypes.func,
  showComponent: PropTypes.func,
  toChangeName: PropTypes.bool,
  toChangePrimary: PropTypes.bool,
  toUpdate: PropTypes.bool,
  updateDone: PropTypes.bool
};

const mapStateToProps = state => ({  
  ...myAccountDerivedStates(state.toJS()),

});

export const mapDispatchToProps = dispatch => ({
  requestData: data => dispatch(fetchMyAccountData(data)),
  showComponent: () => dispatch(showComponent()),
  changeName: () => dispatch(changeName()),
  newFundName: data => dispatch(newFundName(data)),
  changePrimary: () => dispatch(changePrimary()),
  savePrimaryAccount: data => dispatch(savePrimaryAccount(data)),
  newFundNameForSave: data => dispatch(newFundNameForSave(data)),
  addDesignated: data => dispatch(addDesignated(data)),
  fetchCountryMapping: data => dispatch(fetchMyAccountMapping(data)),
  documentCentreData: data => dispatch(fetchDocumentCentreData(data)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MyAccount)
);
